import {
  configApiRef,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { AnalyticsImplementationBlueprint } from '@backstage/plugin-app-react';
import { createApplicationInsightsAnalytics } from './applicationInsightsAnalytics';

/**
 * Sends the app's analytics events (page views, plugin events) and browser
 * errors to Application Insights, when `app.applicationInsights` is set.
 */
export const telemetryModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AnalyticsImplementationBlueprint.make({
      name: 'application-insights',
      params: define =>
        define({
          deps: { config: configApiRef },
          factory: ({ config }) =>
            createApplicationInsightsAnalytics(
              config.getOptionalString(
                'app.applicationInsights.connectionString',
              ),
            ),
        }),
    }),
  ],
});
